module.exports = __webpack_public_path__ + "static/media/ccc.387db759.jpeg";